export default {
  changeSuccess: 'Successfully modified',
  feeStudent: 'Fee student',
  chargeItem: 'Charge item',
  chargeAmount: 'Charge amount',
  preferentialAmount: 'Preferential amount',
  amountReceivable: 'Amount receivable',
  applicableSemester: 'Applicable semester',
  total: 'total',
  paymentAccountNumber: 'Payment account number',
  payOpen: 'open',
  payClose: 'close',
  totalAmount: 'Total amount',
  totalAmountReceivable: 'Total amount receivable',
  totalAmountCharges: 'Total amount of charges',
  totalPreferentialAmount: 'Total preferential amount',
  chargeNumber: 'Charge item No',
  accountingPeriod: 'Accounting period',
  beneficiaryName: 'PayeeAccountName',
  beneficiaryBank: 'Name of deposit bank',
  beneficiaryAccount: 'beneficiary account no',
  newStudentPaymentNotice: 'New student payment notice',
  viewFullChargeInformation: 'View full charge information',
  newApplicant: 'New Applicant',
  pendingRequests: 'Pending Requests',
  submitApplication: 'submit application',
  homeTip: 'Please submit your application information in time in order not to affect your assessment',
  wechatID: 'Wechat ID',
  applyGrade: 'Apply Grade',
  student: 'School Students',
  reMark: 'MessageNew',
  plateNumber: 'PlateNumber',
  attendance: 'Atendance',
  applicationExpired: 'Application expired',
  applicationTip: 'Application is overdue, please click submit application',
  alertTip: ' have not completed your application, please submit it in time',
  addApplicants: 'Add new applicants',
  chooseChildren: 'Choose Children',
  applyTip: 'Tip: Do not fill in the same form for the same student or the expired student. Just select the student you want to apply for.',
  exposureChannel: "Earliest exposure channel",
  exposureTip: 'Where did you first learn about school?',



  wxSchoolName: 'Nanwai King\'s College School Wuxi',
  ksSchoolName: 'Kunshan Dibang Huayao School',
  hzSchoolName: 'RDFZ King\'s College School Hangzhou',
  tsSchoolName: 'Test Collegiate School',
  rdfzxsSchoolName: 'RDFZ XISHAN SCHOOL',
  rdfztxSchoolName: 'RDFZ Tongzhou Campus,Sino-foreign cooperation',
  rdfzsjsSchoolName: 'RDFZ SHIJINGSHAN SCHOOL',
  kcscdSchoolName: 'KING\'s COLLEGE SCHOOL CHENGDU',
  common: {
    gender: {
      male: 'male',
      female: 'female',
    },
    selection: {
      true: 'true',
      false: 'false',
    },
  },
  login: {
    mobileLogin: 'Login',
    enterMobile: 'Please enter mobile phone number!',
    enterMobilePlaceholder: 'Enter mobile phone number',
    countryPlaceholder: 'select country',
    country: 'Please select country!',
    enterVerifyCode: 'Please enter verify code!',
    enterVerifyCodePlaceholder: 'Enter verify code',
    sendVerifyCode: 'Get verify code',
    resendVerifyCode: 'Reacquire after {timer}s',
    login: 'Login',
    loginAuto: 'Automatic login within 7 days',
    emailTitle: 'Contact email',
    sendVerifyCodeSuccess: 'Verify code sent successfully',
    sendVerifyCodeFail: 'Verify code sending failed',
    loginTip: 'Please login!',
    accountNotExist: 'The account does not exist！',
    firstLoginTip: 'For the first time, we will automatically register your mobile phone number as your account.',
  },
  logout: 'Sign out',
  backToHome: 'Back To Home',
  location: {
    road: 'No. 188 Qingyuan Road',
    district: 'Binhu District',
    city: 'Wuxi, Jiangsu 214200',
    country: 'China',
  },
  admissionsContact: 'ADMISSIONS CONTACTS',
  router: {
    home: 'Home',
    introduction: 'Introduction',
    studentDetail: 'Student Detail',
    userCenter: 'User Center',
    message: 'Message',
    detail: 'Message Detail',
    sent: 'Outbox',
    inbox: 'Inbox',
    notice: 'Send Message',
  },
  pleaseSelect: 'Please select',
  pleaseEnter: 'Please enter',
  pleaseEnterAddress: 'Please enter a detailed address',
  beforeApplicantTip1: '如您希望申请{schoolName}，请填写以下《学校申请表》，并等候我们的面谈通知。',
  beforeApplicantTip3: '您可在页面右上方切换语言。',
  beforeApplicantTip5: '中国籍学生请务必在中文界面填写表格。',
  beforeApplicantTip2: 'If you’d like to apply to {schoolName}, please complete the form below and wait for our notice for the interview.',
  beforeApplicantTip4: 'You can switch languages at the top right of the page.',
  beforeApplicantTip6: 'Be sure to switch the form to Chinese before filling this form if you are Chinese.',
  applicationForm: {
    basicInformation: 'Basic Information',
    studentInfor: 'Student information',
    parentsInfor: 'Parents information',
    student: 'Student',
    parents: 'Parent',
    addParentsInfo: 'Add parent/guardian',
    applicationConfirmation: 'Application confirmation',
    applicationConfirmationTmp: 'Information Confirmation',
    chineseName: 'Chinese Name',
    englishName: 'English Name',
    studentName: 'Student Name',
    firstName: 'First name',
    lastName: 'Last name',
    nameChinese: 'Name(Chinese)',
    namePinyin: 'Name(Pinyin)',
    tip1: 'Chinese and English names are required',
    tip5: 'Name (Chinese), name (Pinyin) and English name are required',
    tip2:
      'For Chinese students, please fill in the name as appears on the ID card or Hukou (in Chinese Character). For foreign students, please fill in the name as appears on the passport.',
    pinyinTip1: 'Example: Wang',
    pinyinTip2: 'Example: XiaoQiang',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    dateOfBirth: 'Date of Birth',
    nationality: 'Nationality(Must Match Passport)',
    language: 'Language',
    chinese: 'Chinese',
    english: 'English',
    other: 'Other',
    cardType: 'I.D. Type',
    IDCard: 'ID Card',
    passport: 'Passport',
    cardNumber: 'Card Number',
    applicationInfor: 'Application information',
    applicationSchool: 'Campus',
    applicationSchoolTmp: 'Campus',
    schoolTip:
      'Chinese applicants are bilingual schools, and foreign applicants are international schools. If you need to modify the school, please contact the admissions teacher.',
    applicationYear: 'Applying for School Year',
    applicationEnterYear: 'Applying for Enter Year',
    applicationEnterYearTmp: 'Enter Year',
    englishLevel: 'Children\'s English level',
    parEnglishLevel: 'Parents can communicate in English',
    hobby: 'Hobby',
    hobbyTip: 'Does the applicant have any special interests and strengths? (please list the names, experiences, time spent each week, participation level, honor and awards in order)',
    hobbyTipTmp: 'Does the student have any special interests and strengths? (please list the names, experiences, time spent each week, participation level, honor and awards in order)',
    achievement: 'Academic and personal achievements',
    achievementTip: 'Please describe your past academic achievements and honors',
    achievementTipTmp: 'Please describe your past academic achievements and honors',
    tip3: 'If you need to change the application grade, please contact the admissions teacher.',
    tip3Tmp: 'If you need to change the student grade, please contact the admissions teacher.',
    tip4: 'Be sure to select your applying grade according to applicant’s birth date (only for {currentYear} academic year applicants):',
    tip4Tmp: 'Be sure to select your applying grade according to student’s birth date (only for {currentYear} academic year students):',
    applicationGrade: 'Applying Section',
    applicationGradeTmp: 'Section',
    currentSection: 'Current Section',
    studyingAt: 'Current School Name',
    accommodation: 'Boarding',
    accommodationTip: 'Boarding is optional for Grade 6-12.',
    schoolBus: 'School Bus',
    yes: 'Yes',
    no: 'No',
    mobile: 'mobile',
    verificationCode: 'Verification code',
    resendVerifyCode: 'Reacquire after {timer}s',
    sendVerificationCode: 'Send the verification code',
    parentChineseName: 'Parent/Guardian name',
    parentEnglishName: 'Parent/Guardian english name',
    parentName: 'Parent Name',
    firstGuardian: 'First Guardian Name',
    secondGuardian: 'Second Guardian Name',
    relationship: 'Relationship with student',
    highestEducation: 'Highest Education',
    graduatedSchool: 'Graduated School',
    idNumber: 'ID number',
    workAddress: 'Work unit address',
    employer: 'Company',
    position: 'Title/Position',
    mail: 'Email',
    address: 'Home Address',
    census: 'Census',
    source: 'Referral Source',
    siblingInfo: 'Student sibling information',
    childrenName: 'name',
    isStudyingAt: 'Is it a student of the school?',
    addSibling: 'Add Sibling',
    previous: 'Previous',
    next: 'Next',
    saveToDraft: 'Save to draft',
    successSave: 'Save draft successfully',
    submit: 'Submit',
    account: 'The mobile phone number is your login account.',
    isHasSibling: 'Are there brothers and sisters?',
    checkSibling: 'Please fill in the complete sibling information!',
    checkAddress: 'Please fill in the full address information!',
    checkAddress2: 'Please fill in the complete household registration information!',
    checkSchoolAddress: 'Please fill in the complete school district / county!',
    checkCensusAddress: 'Please fill in the district and county where the account is located!',
    checkSchoolRoll: 'Please fill in complete student registration information!',
    studentExist: 'The student has applied!',
    ageInvalid: 'Your child\'s age does not meet the application requirements, please contact the admissions teacher.',
    verifyCodeWrong: 'Verification code error',
    successApplicant: 'Successful application submission',
    tip6:
      'The system has automatically generated an account for you, the account number is your mobile phone number, and the password is a dynamic verification code.',
    enterCount: 'Enter my account',
    isEmergencyContact: 'Is it an emergency contact?',
    emergencyContact: 'Emergency Contact',
    isFirstContact: 'First Contact',
    firstContact: 'First Contact',
    emergencyContactName: 'EmergencyContact Name',
    draftTip: 'Please fill in your name, English name and gender before saving your draft!',
    draftTip2: 'Please fill in your name and gender before saving your draft!',
    unsubmitted: 'Unsubmitted',
    unsubmittedTip: 'The application form is not completed, please complete it in time!',
    unsubmittedTipTmp: 'The form is not completed, please complete it in time!',
    hasDraftTip: 'If you have an unsubmitted applicant, please submit it first!',
    hasDraftTipTmp: 'If you have an unsubmitted form, please submit it first!',
    userInfo: 'User Information',
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
    changeMobile: 'Modify mobile number',
    originalMobile: 'Original mobile number',
    newMobile: 'New mobile number',
    noModifyTip: 'Please go to the personal center to modify the parent\'s personal information.',
    addAreaCode: 'Please add the area code.',
    hzBoardingTip: 'Boarding is optional for Year8-year13.',
    schoolNowTip: 'Please fill in the full name of the school you are attending now.',
    photoIsRequired: 'Certificate photo is required',
    IDIsRequired: 'applicant\'s ID card (front and back) or passport is required',
    admissionDate: 'Admission Date',
    accountMobile: 'Account',
    addressTip: 'The address must be accurate to the house number/room number',
    enNameTip: 'Please fill in the English name of your child correctly, and it will not be changed when registering in the relevant system after enrollment.',
    activityInfo: 'activity information',
    activityName: 'Activity Name',
    channelName: 'Channel',
    schoolVisitTime: 'Activity time',
    activityStatus: 'Activity status',






    // sourcePlaceholder: {
    //   54: 'Please fill in the recommended source',
    //   72: 'Please fill in the recommended source',
    //   292: 'Please fill in the recommended source',
    //   55: 'Please fill in the name of the school staff',
    //   320: 'Please fill in the name of the school student',
    //   60: 'Please fill in WeChat public account',
    //   61: 'Please fill in the name of the exhibition',
    //   62: 'Please fill in the name of the broadcast newspaper and magazine',
    //   63: 'Please fill in the news client name',
    //   64: 'Please fill in the recommended source',
    //   123: 'Please fill in the name of the school staff',
    //   321: 'Please fill in the name of the school student',
    //   128: 'Please fill in WeChat official account',
    //   129: 'Please fill in the name of the exhibition',
    //   130: 'Please fill in the name of the broadcast newspaper and magazine',
    //   131: 'Please fill in the news client name',
    //   132: 'Please fill in the recommended source',
    // },
    sourcePlaceholder: {
      54: 'Please fill in the recommended source',
      72: 'Please fill in the recommended source',
      292: 'Please fill in the recommended source',
      55: 'Please fill in the name of the school staff',
      320: 'Please fill in the name of the school student',
      60: 'Please fill in WeChat public account',
      1139: 'Please fill in the name of the exhibition',
      1140: 'Please fill in the name of the broadcast newspaper and magazine',
      63: 'Please fill in the news client name',
      64: 'Please fill in the recommended source',
      123: 'Please fill in the name of the school staff',
      321: 'Please fill in the name of the school student',
      1260: 'Please fill in WeChat official account',
      129: 'Please fill in the name of the exhibition',
      130: 'Please fill in the name of the broadcast newspaper and magazine',
      131: 'Please fill in the news client name',
      1141: 'Please fill in the channel source',
      1400: 'Please fill in the name of the school staff',
      619: 'Please fill in the name of the school student',
      1401: 'Please fill in the name of the school staff',
      1214: 'Please fill in the name of the school student',
      1326: 'Please fill in the name of the school staff',
      1325: 'Please fill in the name of the school student',
      637: 'Please fill in the name of the school staff',
      1273: 'Please fill in the name of the school student',
    },
  },
  filter: {
    chargesType: 'Charge type',
    modifyTime: 'Modify Time',
    schoolVisitTime: 'Activity Session',
    firstDate: 'First consultation Time',


    school: 'School',
    grade: 'Grade',
    applicantDate: 'Applicant Time',
    student: 'Student',
    birthday: 'Birthday',
    parent: 'Parent',
    following: 'Following',
    intentionality: 'Intention',
    enterYear: 'Start year',
    sourceName: 'Referral Source',
    unfold: 'Unfold',
    fold: 'Fold',
    reason: 'Reasons for rejection',
    studentStatus: 'Student Status',
    followingStatus: 'Following Status',
    nextFollowing: 'Next Following',
    fileList: 'File List',
    enterDate: 'Enter Date',
    DateOfVisit: 'Date Of Visit',
    isVisited: 'Status',
    interviewDate: 'Interview Date',
    type: 'Type',
    title: 'Title',
    recipient: 'Recipient',
    sendTime: 'Send Time',
    schoolYear: 'School Year',
    role: 'Role',
    name: 'Name',
    checkStatus: 'Reconciliation status',
    paymentStatus: 'Payment Status',
    paidStatus: 'Payment Status',
    paidTime: 'Payment Time',
    refundTime: 'Refund time',
    depositTime: 'Deposit Time',
    sendOfferTime: 'Offer Time',
    submitForm: 'Payment Status',
    isSendMsg: 'Is send Message',
    sender: 'Sender',
    receiveTime: 'Receive Time',
    interview: 'Interview',
    city: 'City',
    gender: 'Gender',
    reasons: 'Invaild Reason',
    boarding: 'Boarding',
    schoolBus: 'School Bus',
    labelList: 'Label List',
    submitTime: 'Payment Time',
    uniformSubmitTime: 'Payment Time',
    activityName: 'Activity Name',
    enquiryDate: 'Enquiry Date',
    childName: 'Child Name',
    residence: 'Residence',
    isEnquiry: 'Enquiry',
    teacherAttendance: 'Attendance',
    applicantSubmitDate: 'Submit Time',
    typeOfAssessment: 'Type of assessment',
    reasonForTransfer: 'Reasons For Transfer',
    transferDate: 'Transfer Date',
    class: 'Class',
    channelName: 'Channel Name',
    midtermExam: 'Midterm Exam',
    studentType: 'Student Type',
    currentSchool: 'Current School',
    hasBankAccount: 'Has Bank Account',
    bankAccount: 'Bank Account',
    studentStatusType: 'Student Type',
    studentID: 'Student ID',
    createTime: 'Create Time',
    semester: 'Semester',
    applicableSemester: 'Applicable Semester',
    orderStatus: 'Order Status',
    orderType: 'Order Type',
    nationality: 'Nationality',
    tuitionStatus: 'Tuition Status',
    tuitionType: 'Tuition Type',
    parentReply: 'Parent Reply',
    applicationGrade: 'Grade',
    studentGrade: 'Student Grade',
    cityOfResidence: 'City',
    census: 'Census',
    applySection: 'Apply Grade',
    statisticsTime: 'Statistics Time',
    activityDate: 'Activity Date',
    collectionTime: 'Collection Time',
    transferTime: 'Transfer time',
    currentGrade: 'Current Grade',
    mobile: 'Mobile',
    invaildReason: 'Invaild Reason',
    isApplied: 'is Applied',
    yearOfApplication: 'Enrolment Year',
  },
  userCenter: 'User Center',
  currentStatus: 'status',
  delete: 'Delete',
  applyOnline: 'Apply Online',
  applyOnlineTmp: 'Fill in the information',
  warningTip: {
    nameInvaild: 'Only Chinese can be entered and the length is between 1-50.',
    enNameInvaild: 'English name is required, the length is between 1-50, and only letters can be entered.',
    pinyinNameInvaild: 'Pinyin name is required and the length is between 1-50.',
    idNumberInvaild: 'The ID number is required and the length is between 1-50.',
    mobileInvaild: 'Mobile number is required and both are numbers',
    workUnitInvaild: 'Working unit is required, and the length is between 1-50.',
    positionInvaild: 'The position is required and the length is between 1-50.',
    schoolNowExtraInvaild: 'Now the school is required and the length is between 1-50.',
    addressInvaild: 'The address is required and the length is between 1 and 50.',
    siblingNameInvaild: 'Child name is required and the length is between 1-50.',
    leaveFromForm: 'Leave this site? Your changes may not be saved!',
    schoolExtraInvaild: 'No more than 50 characters in length',
    valueLen150: 'No more than 150 characters in length',
    remarkInvaild: 'No more than 2000 characters in length',
    vCodeNotNull: 'Verification code must be filled',
    originalMobileWrong: 'The original mobile number is incorrect',
    modifyMobileSuccess: 'Successfully modified',
    tip404: 'Sorry, the page you visited does not exist.',
    tip500_1: 'Sorry, the webpage you specified cannot be accessed. ',
    tip500_2: 'You can scan the code to add the enrollment assistant to consult.',
    applicantSuccess: 'The application form is submitted successfully!',
    numberInvaild: 'This field is required and both are numbers',
    rankingInvaild: 'Please fill in the number or rank / number',
    valueInvalid: 'This field is required and the length is between 1 and 50.',
    valueNumInvaild: 'This field is required and the length is between 1 and 100.',
    contentNotEmpty: 'This content field is required',
    numberLenInvaild: 'This field is required and the length is between 1 and 50.',
    enquiryMobileInvaild: 'Please fill in the correct mobile phone number.',
    emailInvaild: 'Please enter a valid email',
    scoreInvaild: 'Please fill in the number or 无',
    valueNotMoreThen10: 'No more than 10 characters',
  },
  confirmSubmit: 'Confirm submission of application form?',
  confirmSubmitTmp: 'Confirm submission of form?',
  // confirmSubmitTip: 'The application form cannot be modified after submission. If you want to modify, please contact the admissions teacher',
  confirmSubmitTip: 'After submission, if you need to modify the application information, please go to the home page and click the student card to enter the student information page for modification.',

  confirmSubmitTipTmp: 'The form cannot be modified after submission. If you want to modify, please contact the admissions teacher',
  sendMessage: 'Send Message',
  MessageColumns: {
    no: 'No',
    type: 'Type',
    title: 'Title',
    sendBy: 'Send By',
    sendTime: 'Send Time',
    content: 'Content',
    recipent: 'Recipent',
    receiveTime: 'Receive Time',
  },
  uploadFile: 'Upload',
  upload: 'Upload',
  checklist: 'Attachment list',
  checklistTip2: '(Please submit the list before the interview.)',
  checklistTip: ' After the checklist is submitted, it cannot be deleted.File or picture within 10M.',
  fileTip: 'File or picture within 10M',
  file1: 'Applicant ID (front and back) or passport',
  file1Tmp: 'Student ID (front and back) or passport',
  file1Tip: 'If you do not have an ID card, please upload the applicant account page.',
  file1TipTmp: 'If you do not have an ID card, please upload the student account page.',
  file2: 'Parent or guardian ID (front and back) or passport',
  file3: 'Photo of the applicant\'s electronic version in the last 6 months (2 inches)',
  file3Tmp: 'Photo of the student\'s electronic version in the last 6 months (2 inches)',
  file4: 'Document',
  file4Tip: 'Applicants\' transcripts, academic year certificates and other related certificates from the past 2 academic years',
  file4TipTmp: 'Students\' transcripts, academic year certificates and other related certificates from the past 2 academic years',
  file5: 'Vaccine certification',
  file5Tip: 'No need to submit for grade 2 and above',
  chooseFile: 'Choose file',
  ok: 'OK',
  signin: 'Sign In',
  cancel: 'Cancel',
  uploadSuccess: 'Uploaded successfully',
  fileTypeErr: 'File type error!',
  fileSizeErr: 'File size does not exceed 10M',
  fileSize30MErr: 'File size does not exceed 30M',
  todoTip: 'You have {num} unuploaded file.',
  newMessageTip: 'Received {num} new message.',
  message: 'Message',
  receiveTime: 'Receive Time',
  sendBy: 'sent By',
  msgContent: 'Content',
  attachment: 'Attachment',
  attachmentTip: 'Attachments are limited to 10M, add up to 10.',
  picTip: 'Pictures are limited to 10M, add up to 10.',
  remark: 'Remark',
  remarkInfo: 'Remark Info',
  uniformBook: 'Clothing Book',
  paymentRecord: 'Payment Record',
  uniformTip: '(Student clothing size and payer information can be modified before 2020/05/01)',
  height: 'Height(cm)',
  weight: 'Weight(kg)',
  size: 'Size',
  payerInfo: 'Payer Info',
  payerName: 'Payer Name',
  payerMobile: 'Payer Mobile',
  bankAccount: 'Bank Account',
  bankName: 'Bank Name',
  alipay: 'Alipay',
  email: 'Email',
  paymentMethod: 'Payment Method',
  uniformPrice: '(School clothing deposit is ￥8,000)',
  payByAlipay: 'Alipay scan code payment',
  bankTransfer: 'Bank Transfer',
  certificate: 'Certificate',
  payerTip: '(Ensure consistency with payment account)',
  uniformTable: 'Height and weight recommendation table',
  uniformSizeTip: 'Parents are recommended to choose a “moderately larger” clothing size based on information such as "height and weight"; for larger, please fill in the required size in the remarks column.',
  uniformTip3: 'Please fill in your detailed home address and the admissions teacher will mail you important materials.',
  uniformTip1: 'If transfer by other methods, please fill in none',
  uniformTip2: 'For bank transfer, please fill in none',
  uploadReceipt: 'Upload receipt',
  uploadTip: '(After uploading, it cannot be deleted)',
  receiptTemplate: 'Receipt Template',
  fillUniformInfo: 'Fill in clothing information',
  submitSuccess: 'Submitted successfully',
  signInSuccess: 'Sign In Successfully',
  recipient: 'Recipient',
  title: 'Title',
  content: 'Content',
  addRecipient: 'Add Recipient',
  send: 'Send',
  selectRecipient: 'Please select the recipient',
  sendSuccess: 'Sent successfully',
  replyMsg: 'Reply',
  receiveBy: 'Receive By',
  sendTime: 'Send Time',
  studentList: 'Teacher List',
  selectedStud: 'Total selected {num}',
  deleteAll: 'Delete All',
  stuNum: '(Total {num})',
  selectAll: 'Select All',
  sender: 'Sender',
  messageTable: {
    type: 'Type',
    title: 'Title',
    content: 'Content',
    toMember: 'Recipient',
  },
  resourceNotEmpty: 'Receipt voucher cannot be empty',
  uploadPic: 'Upload image',
  uniformSubmitTip: 'Dear parents, you have successfully submitted, and an enrollment teacher will contact you later, thank you for your cooperation and waiting.',
  payeeConfirm: 'Please confirm that the payee is:',
  loadingMore: 'Loading More',
  loginTip: 'To apply for multiple children from the same family, please log in / register with the same mobile phone number',
  activityInvaild1: 'Activity has not started ~',
  activityInvaild: 'Activity has expired ~',
  activityError: 'No activity ~',
  activityInvaildTip: 'The active period of the activity is: {startTime} - {endTime}',
  enquiryWelcome: 'Welcome to sign up for "{activityName}"',
  censusRegister: 'Census Register',
  schoolRoll: 'School Roll',
  IDCard: 'ID Number',
  currentGade: 'Current Gade',
  emailTip: 'This mailbox is used to receive important information',
  examResults: 'Exam Results',
  gradeOfThirdGrade: 'Total score for final grade of the third grade',
  gradeOfThirdGradeRank: 'Ranking of the last three classes',
  firstSimulationResults: 'Total score for first simulation score',
  firstSimulationRank: 'District ranking for the first mock exam',
  secondSimulationResults: 'Total score for second simulation score',
  secondSimulationRank: 'District ranking for the second mock exam',
  juniorHighSchoolResult: 'Total score for junior high school results',
  districtRanking: 'District Ranking',
  subject: 'Subjects for high school entrance examination (three out of five)',
  biochemistry: 'Biochemistry',
  physical: 'Physical',
  history: 'History',
  geography: 'Geography',
  political: 'Political',
  eachScores: 'High school entrance examination scores (including sports)',
  eachScoresTip: 'Please fill in the Chinese, mathematics, English paper, oral English, three selected subjects and physical education scores',
  standardizedScore: 'Standardized test',
  standardizedScoreTip: 'If there are no results, please write "None", which can be completed later.',
  toefl: 'TOEFL',
  ielts: 'IELTS',
  others: 'Other',
  personalDisplay: 'Personal display',
  hobbies: 'Hobbies',
  awards: 'Awards',
  hobbies1: 'A book / a show / a hobby that you like or influence the most',
  choiceReason: 'Why did you choose the AP project of {schoolName} attached to the National People\'s Congress?',
  qualities: 'Which qualities do you think are in line with the {schoolName} attached to the NPC?',
  resume: 'Resume',
  rankInputFormat: 'Rank / Number',
  studentType: 'Student Type (Census)',
  registrationNumber: 'Entrance Examination Registration ID',
  schoolAddress: 'The county where the school is located',
  censusAddress: 'Country where the hukou is located',
  homeAddress: 'Home address',
  nation: 'Nation',
  member: 'is Member',
  workAddress: 'Work unit',
  completeScores: 'Completion of scores',
  completeBankInfo: 'Register CITIC Bank Card Information',
  accountParentName: 'Parent Name',
  accountParentIDNumber: 'Parent ID Number',
  accountTip: 'Please make sure the information is correct, it cannot be modified after submission.',
  bankInfo: 'CITIC Bank Card Information',
  subjectInvaild: 'Please choose three subjects',
  applicationNotes: 'Application Notes',
  stuName: 'Student Name',
  stuGender: 'Student Gender',
  stuBirthday: 'Student Birthday',
  stuIdNumber: 'Student ID Number',
  wechatTip: 'Add a WeChat assistant to get more information',
  awardsOrHonors: 'Awards and honors at home and abroad, foreign study experience, etc., which best reflect the students\' abilities',
  questionAboutSchool: 'What do you want to know about our school',
  suggestion: 'Your suggestions for the development of our school (or what you think our school needs to improve and strengthen)',
  questionAboutAdmission: 'What questions do you want to ask about enrollment',
  resumeTip: 'Please upload in pdf format, within 30M',
  confirmSubmit2: 'Confirm submission of application form?',
  submitTip: 'The basic information of the student cannot be modified after submission. Examination results such as: first-mode, second-mode, middle-level examination, and standardized examination results can be modified and completed.',
  downloadApplicant: 'Print on-site confirmation',
  orderDetailTable: {
    charges: 'Charge items',
    chargeAmount: 'Charge item amount (yuan)',
    discount: 'Preferential amount (yuan)',
    amountReceivable: 'Receivable amount (yuan)',
    applicableSemester: 'Applicable semester',
    operation: 'Operation',
    studentName: 'Student name',
    grade: 'Application grade',
    school: 'School',
    enterYear: 'EnterYear',
    creator: 'Creator',
    createTime: 'Create Time',
  },
  otherFee: 'Other Fee',
  orderTable: {
    name: 'Student name',
    id: 'Student ID',
    bankAccount: 'Bank account number',
    grade: 'Grade',
    charges: 'Charge items',
    totalCharges: 'Total amount of charges (yuan)',
    totalDiscount: 'Total discount amount (yuan)',
    totalReceivable: 'Total amount receivable (yuan)',
    totalPaid: 'Total amount paid (yuan)',
    totalOwed: 'Total amount owed (yuan)',
    orderStatus: 'Order Status',
    orderNumber: 'Order Number',
    orderType: 'Order Type',
    createTime: 'Create Time',
  },
  tip: {
    noVisitTime: 'The department has no activity sessions',
    fullVisitTime: 'The appointment is full, the time is to be determined',
  },
};
